import { start } from "./start.js";
import type { FetchLike } from "./api-client.js";
import type { GsiWindow } from "./google-sign-in.js";

/**
 * Browser entrypoint. Like the server entrypoint, it holds no logic — it only
 * hands the real `document`, `window` and `fetch` to {@link start}.
 *
 * The window cast is the one unavoidable lie: `window.google` is added at
 * runtime by the Google Identity Services script tag, so the DOM lib cannot
 * know about it. {@link GsiWindow} declares it optional, which is exactly how
 * the adapter treats it.
 */
void start({
  document,
  window: window as unknown as GsiWindow,
  fetch: ((input, init) => fetch(input, init)) as FetchLike,
});
